import CONSTANT from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'

const { CLUSTERS_API_URL } = CONSTANT

const getEksClusterVersions = async (): Promise<{
	statusCode: number
	body: string[]
	message?: string
}> => {
	const response = await fetchWithAuthorizationHeader(
		`${CLUSTERS_API_URL}?eksVersions=true`
	)
	const data = await response.json().catch(() => ({
		statusCode: response.status,
		body: [],
		message: 'Unable to load EKS versions from AWS'
	}))
	if (response.status !== 200) {
		throw new Error(data?.message || 'Unable to load EKS versions from AWS')
	}
	return data
}

export default getEksClusterVersions
